export default [
  {
    fileName: "client/vn-dejun2.png",
    link: "https://upromania.ro/utile/legislatie/ordin-484-280-2025/",
    category: "Banner",
    action: "Click",
    label: "Client_vn_dejun",
  },
  {
    fileName: "client/up-onlline-clienti.png",
    link:
      "https://upromania.ro/companii/card-cultural/",
    category: "Banner",
    action: "Click",
    label: "campanie_card_cultura",
  },
];
